import {translations} from 'presentation/translations-new';

const {selectLocation} = translations['pt-br'].commons;
const {requestDetails} = translations['pt-br'].privateFlow.requestAuthorizations.attachments;
enum RequestAuthorizationStep {
	LOCATION = 'LOCATION',
	PROVIDER_SELECTION = 'PROVIDER_SELECTION',
	ATTACHMENTS = 'ATTACHMENTS',
}

const STEPS_LABELS = {
	[RequestAuthorizationStep.LOCATION]: selectLocation,
	[RequestAuthorizationStep.PROVIDER_SELECTION]: selectLocation,
	[RequestAuthorizationStep.ATTACHMENTS]: requestDetails,
};

const stepLabels = [selectLocation, requestDetails];

export {RequestAuthorizationStep, STEPS_LABELS, stepLabels};
